var _style, _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPvAgilidade = function SvgPvAgilidade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 512,
    height: 512
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.5,318.6h64.2c4.5,0,8.5-5.9,8.5-12.4c0-6.5-4-12-8.5-12h-47.2v-1.6c0-16.4,55.7-29.1,55.7-68.2 c0-24.1-21.1-37.2-42-37.2c-20.5,0-40.7,12.6-40.7,34.5c0,11.3,5.4,14.6,12.6,14.6c9.2,0,14.8-5,14.8-10.2 c0-9.9,6.3-13.5,13.5-13.5c10.1,0,13.7,7,13.7,12.8c0,22.8-56.8,39-56.8,67.2V310C112.3,315.2,119.5,318.6,124.5,318.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.9,290.9h42.2V310c0,5.8,7,8.6,14.1,8.6c7,0,14.1-2.9,14.1-8.6v-19.1h7.8c4.3,0,8.7-6.5,8.7-12.9 c0-6.5-2.9-13-8.7-13h-7.8v-12.6c0-5.9-7-8.5-14.1-8.5c-7,0-14.1,2.5-14.1,8.5V265h-15.5l31.9-63.8c0.5-1.3,0.9-2.3,0.9-3.4 c0-6.5-9.2-10.6-14.1-10.6c-4.5,0-9,2-11.7,7.2L206,275.8c-1.1,2-1.4,4-1.4,5.4C204.6,287.5,208.7,290.9,213.9,290.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.4,184.1c-8.1,0-13.9,3.4-13.9,8.4V310c0,4.3,5.8,8.6,13.9,8.6c7.6,0,14.1-4.3,14.1-8.6v-40.3 c0-8.5,6.1-13.5,12.1-13.5c7,0,13,6.7,13,13.5V310c0,5.8,7.4,8.6,13.9,8.6c7,0,14.1-2.9,14.1-8.6v-40.3c0-20.7-14.2-37.8-30.6-37.8 c-11.2,0-19.1,6.7-22.3,13.7v-53C343.5,187.5,337,184.1,329.4,184.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,255.8c0-68.3-26.7-132.5-75.1-180.8C388.5,26.6,324.1,0,255.7,0c-7.9,0-14.4,6.1-15,13.9 c0,0.3-0.1,0.7-0.1,1.1v0v0v0v40.4c0,8.3,6.7,15,15,15c8.3,0,15-6.7,15-15V30.5c54.8,3.6,105.8,26.5,145,65.6 c39.2,39.1,62.2,90,65.8,144.7h-24.9c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15h24.9c-3.6,54.7-26.6,105.6-65.8,144.7 c-39.2,39.1-90.2,62.1-145,65.6v-24.9c0-8.3-6.7-15-15-15c-8.3,0-15,6.7-15,15v25.3c-39.6-2.7-77.7-15.8-111-38.2 c-38.6-26-67.8-62.7-84.6-106.2c-8.2-21.4-13.1-43.8-14.6-66.3h24.3c8.3,0,15-6.7,15-15c0-8.3-6.7-15-15-15H30.6 c0.5-7.4,1.4-14.8,2.6-22.2c4.6-27.3,14.3-53.4,28.3-77.1l2.5,13c1.4,7.2,7.7,12.1,14.7,12.1c0.9,0,1.9-0.1,2.9-0.3 c8.1-1.6,13.5-9.4,11.9-17.6L84.2,101c-1.6-8.1-9.5-13.4-17.6-11.9l-47.9,9.3C10.6,100,5.3,107.9,6.8,116s9.5,13.4,17.6,11.9 l11.5-2.2c-16.1,27-27.1,56.9-32.4,88c-7.7,45-3,91.4,13.5,134.2c19,49.3,52.1,90.9,95.8,120.3c42.7,28.7,92.3,43.8,143.5,43.8h0.3 c1.3,0,2.7,0.1,3.9,0c66.6-1.2,129-28.2,176.3-75.4C485.3,388.3,512,324.1,512,255.8"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPvAgilidade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pv-agilidade.9af1b791.svg";
export { ForwardRef as ReactComponent };